import * as requestServices from "../request";

export const req = {

    getClientMappedData(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
    getClientLinkedData(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
    getTaxNotLinkedData(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
    getAllClients(url, firmId, clientId, searchCriteria) {
        if (searchCriteria == null)
            searchCriteria = {};
        searchCriteria.firmId = firmId;
        if (clientId != null)
            searchCriteria.clientId = clientId;

        return requestServices
            .post(url, searchCriteria)
            .then(data => data)
            .then(res => {
                return res;
            })
    },
    getClientTypesLookUp(url) {
        return requestServices
            .get(url)
            .then(data => data)
            .then(res => {
                return res;
            })
    },
    getGenerationTypesLookUp(url) {
        return requestServices
            .get(url)
            .then(data => data)
            .then(res => {
                return res;
            })
    },
    getLocationLookUp(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            })
    },
    getLocationLookUp(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            })
    },
    getTaskTypeLookUp(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            })
    },
    getGroupLookUp(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            })
    },
    getClientById(url) {
        return requestServices
            .get(url)
            .then(data => data)
            .then(res => {
                return res;
            })
    },
    setAllClients(url, data) {
        return requestServices.post(url, data)
            .then((data) => (data))
            .then((res) => {
                return res;
            });
    },
    getFirmSettings(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            })
    },
    unlinkClients(url, clientId) {
        return requestServices
            .put(url + "/" + clientId)
            .then(data => data)
            .then(res => {
                return res;
            });
    },

    staffAssignmentLookUp(url, firmId, clientId) {
        return requestServices
            .get(url + "/" + firmId + "/" + clientId)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
    searchUserLookUp(url, firmId, branchId, roleId) {
        return requestServices
            .get(url + "/" + firmId + "/" + branchId + "/" + roleId)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
    updateStaffs(url, data) {
        return requestServices.post(url, data)
            .then((data) => (data))
            .then((res) => {
                return res;
            });
    },
    getFirmDocumentSync(url, firmId) {
        return requestServices
            .get(url + "/" + firmId)
            .then(data => data)
            .then(res => {
                return res;
            });
    },
};